
import user_mixin from '@/mixins/user_mixin';
import { mdiMagnify } from '@mdi/js';
import FullScreenLoader from '~/components/fullScreenLoader.vue';
import Breadcrumbs from '@/components/Shop/Breadcrumbs.vue';
import HyperlinkPagination from '@/components/HyperlinkPagination.vue';

export default {
  props: {
    preview: Boolean,
    products: {
      type: Array,
      default: []
    },
    loading: Boolean,
    pagination: {
      type: Object,
      default: {}
    },
    showSearchBox: Boolean,
    queryParams: {
      type: Object,
      default() {
        return { searchText: '' };
      }
    },
    lastItemName: String
  },
  components: {
    FullScreenLoader,
    Breadcrumbs,
    HyperlinkPagination
  },
  mixins: [user_mixin],
  data() {
    return {
      icons: {
        mdiMagnify
      },
      sortingOverlay: false,
      sortSelectionTabIndex: null,
      sortSelectionRadioValue: null,
      sortRadioOptions: [
        { label: 'Popularity', value: 'popularity_desc' },
        { label: 'Newest First', value: 'newest_desc' },
        { label: 'Price -- Low to High', value: 'price_asc' },
        { label: 'Price -- High to Low', value: 'price_desc' },
        { label: 'Discount -- Low to High', value: 'discount_asc' },
        { label: 'Discount -- High to Low', value: 'discount_desc' },
      ],
      country: {
        symbol: this.$auth?.user?.shopCountry?.currency_symbol ?? '₹'
      },
      searchText: ''
    };
  },
  watch: {
    '$route.query': {
      deep: true,
      async handler(newQuery, oldQuery) {
        let { page, batchSize } = newQuery;
        // const parentComponentName = this.$parent.$options.name;
        // console.log('Parent Component Name:', parentComponentName);
        if (this.$route.path === '/shop') {
          page = 1;
          batchSize = 6;
        }
        // const parentHierarchy = this.getParentHierarchy(this.$parent);
        // console.log('Parent Hierarchy:', parentHierarchy);

        // console.log('query changed === old ', oldQuery, ' new = ', newQuery);
        // console.log('active ==== ', this.$route.meta.isActive);
        // if (this.$route.meta.isActive)
        await this.onPageChange(page, batchSize);
      }
    },
    'pagination.sort': {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) this.changeSortSelection(this.pagination.sort);
      }
    }
  },
  methods: {
    getParentHierarchy(component) {
      const hierarchy = [];
      while (component) {
        hierarchy.push(component.$options.name);
        component = component.$parent;
      }
      return hierarchy;
    },

    showProductDetails(product) {
      this.$router.push(
        `/shop/products/${product.product_url ?? product.product_id}`
      );
    },

    changeSortSelection(value) {
      if (!value) return;

      const index = this.sortRadioOptions.findIndex(
        el => el.value === this.pagination.sort
      );
      this.sortSelectionTabIndex = index + 1;
      this.sortSelectionRadioValue = this.pagination.sort;
      this.updateURL({});
    },
    async productSearchEvent() {
      this.$emit('fetch-products', {});
    },
    onPageChange(
      page = this.pagination.page,
      batchSize = this.pagination.batchSize
    ) {
      this.$emit('onPageChange', { page: +page, batchSize: +batchSize });
    },
    bathSizeChanged(
      page = this.pagination.page,
      batchSize = this.pagination.batchSize
    ) {
      this.updateURL({ page, batchSize });
    },
    searchProducts(_evt, searchText = this.queryParams.searchText) {
      this.pagination.page = 1;
      this.updateURL({ searchText });
    },
    updateURL({
      page = this.pagination.page,
      batchSize = this.pagination.batchSize,
      searchText = this.queryParams.searchText
    }) {
      let url = this.$nuxt.$route.path;
      url += `?page=${page}`;
      url += `&batchSize=${batchSize}`;
      url += `&sort=${this.pagination.sort}`;
      if (searchText) url += `&query=${searchText}`;
      this.$router.push(url);
    }
  },
  async mounted() {
    document
      .getElementById('product-search-field')
      .addEventListener('input', debounce(this.searchProducts));

    const container = this.$refs.shopContainer;

    if (container) container.scrollTop = 0;
    this.changeSortSelection(this.pagination.sort);
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  }
};

const debounce = (fn, interval = 1000) => {
  let timeout = null;
  return (...args) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      return fn(...args);
    }, interval);
  };
};
